<div class="card-container p-3">
  <div class="text-center mb-3">
    <img [src]="!!customerData?.Customer_ProfilePic ? profileUrl : 'assets/images/default-user.png'" class="rounded-circle shadow-sm" style="width: 90px; height: 90px; object-fit: cover; border: 3px solid var(--theme-primary, #123c53);">
    <h5 class="mt-2 mb-0 font-weight-bold" style="color: #1e293b; font-size: 1rem;">{{ customerData?.['Customer_Name'] }}</h5>
    <span class="badge badge-pill badge-primary mt-1" style="background: var(--theme-primary, #123c53); font-weight: 600; padding: 0.35em 0.8em;">
      {{ customerData?.AC_CustomerType }}
    </span>
  </div>

  <div class="customer-info-list" style="display: flex; flex-direction: column; gap: 0.5rem;">
    
    <div class="info-row p-2 rounded" style="background: #f8fafc; border: 1px solid #f1f5f9;">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.6875rem;">
        <i class="fas fa-map-marker-alt text-primary mr-1"></i>
        <span *ngIf="customerData?.Customer_IsFirm == 'False'">Permanent Address</span>
        <span *ngIf="customerData?.Customer_IsFirm == 'True'">Registered Address</span>
      </div>
      <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">
        {{ customerData?.Address1 }}<span *ngIf="customerData?.Tehsil1">, {{ customerData?.Tehsil1 }}</span><span *ngIf="customerData?.District1">, {{ customerData?.District1 }}</span><span *ngIf="customerData?.State1">, {{ customerData?.State1 }}</span> <span *ngIf="customerData?.PIN1">- {{ customerData?.PIN1 }}</span>
      </div>
    </div>

    <div class="info-row p-2 rounded" style="background: #f8fafc; border: 1px solid #f1f5f9;" *ngIf="customerData?.Address2">
      <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.6875rem;">
        <i class="fas fa-building text-primary mr-1"></i>
        <span *ngIf="customerData?.Customer_IsFirm == 'False'">Present Address</span>
        <span *ngIf="customerData?.Customer_IsFirm == 'True'">Corporate Address</span>
      </div>
      <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">
        {{ customerData?.Address2 }}<span *ngIf="customerData?.Tehsil2">, {{ customerData?.Tehsil2 }}</span><span *ngIf="customerData?.District2">, {{ customerData?.District2 }}</span><span *ngIf="customerData?.State2">, {{ customerData?.State2 }}</span> <span *ngIf="customerData?.PIN2">- {{ customerData?.PIN2 }}</span>
      </div>
    </div>

    <div class="row m-0">
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">
            <i class="fas fa-calendar-alt text-info mr-1"></i> DOB / Date
          </div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">
            {{ customerData?.Customer_DOB | date: 'dd/MM/yyyy' }}
          </div>
        </div>
      </div>
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">
            <i class="fas fa-venus-mars text-info mr-1"></i> {{ customerData?.Gender == 'Firm' ? 'Type' : 'Gender' }}
          </div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">
            {{ customerData?.Gender }}
          </div>
        </div>
      </div>
    </div>

    <div class="row m-0">
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">
            <i class="fas fa-phone-alt text-success mr-1"></i> Mobile
          </div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">
            {{ customerData?.Customer_PhoneNo }}
          </div>
        </div>
      </div>
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">
            <i class="fas fa-user-tag text-warning mr-1"></i> Profile
          </div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">
            {{ customerData?.Profile }}
          </div>
        </div>
      </div>
    </div>

    <div class="row m-0" *ngIf="customerData?.Category || customerData?.Sub_Category">
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">Category</div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">{{ customerData?.Category }}</div>
        </div>
      </div>
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">Sub Category</div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">{{ customerData?.Sub_Category }}</div>
        </div>
      </div>
    </div>

    <div class="row m-0" *ngIf="customerData?.BusinessCategory || customerData?.Nature_of_work">
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">Business Cat</div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">{{ customerData?.BusinessCategory }}</div>
        </div>
      </div>
      <div class="col-6 p-1">
        <div class="p-2 rounded h-100" style="background: #f8fafc; border: 1px solid #f1f5f9;">
          <div class="small text-uppercase font-weight-bold text-muted" style="font-size: 0.65rem;">Nature of Work</div>
          <div class="font-weight-600 text-dark" style="font-size: 0.8125rem;">{{ customerData?.Nature_of_work }}</div>
        </div>
      </div>
    </div>

  </div>
</div>
